import {useId} from 'react';

import Popup from '@/components/Popup/Popup';
import MetricDetail from '@/containers/ExperienceScore/DetailedInsight/MetricDetail';
import useHideMenu from '@/hooks/useHideMenu';
import useStickyWhileOpen from '@/hooks/useStickyWhileOpen';

interface ExperienceScoreDetailedInsightModalProps {
    open: boolean;
    insightId: string | null;
    onClose: () => void;
}

const ExperienceScoreDetailedInsightModal = ({open, insightId, onClose}: ExperienceScoreDetailedInsightModalProps) => {
    // Keeps the id rendered while the drawer animates closed, instead of going blank the instant the URL param clears.
    const stickyInsightId = useStickyWhileOpen(insightId, open);
    const titleId = useId();
    const isMenuHidden = useHideMenu(open);

    if (!stickyInsightId) return null;

    return (
        <Popup open={open && isMenuHidden} onOpenChange={(isOpen) => !isOpen && onClose()} aria-labelledby={titleId}>
            <MetricDetail code={stickyInsightId} titleId={titleId} onClose={onClose} />
        </Popup>
    );
};

export default ExperienceScoreDetailedInsightModal;
